import axios from "axios";
import {
  IClaveUnicaLoginResponse,
  IClaveUnicaTokenResponse,
} from "constants/interfaces/auth.interface";
import { getAuthToken } from "helpers/Auth";

/**
 * Obtiene la autorización de Clave Única.
 *
 * @param {string} token Token anti-falsificación "state".
 * @return {Promise<void>}
 */
export const getAuthorization = async (token: string): Promise<void> => {
  try {
    const params = {
      client_id: process.env.REACT_APP_CLAVEUNICA_CLIENT_ID,
      response_type: "code",
      scope: "openid run name",
      state: token,
      redirect_uri: process.env.REACT_APP_CLAVEUNICA_REDIRECT_URI,
    };
    const url = `${process.env.REACT_APP_CLAVE_UNICA_BASE_URL}/openid/authorize/?client_id=${params.client_id}&response_type=${params.response_type}&scope=${params.scope}&state=${params.state}&redirect_uri=${params.redirect_uri}`;
    window.open(url, "_self").focus();
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Método que obtiene el token de Clave Única.
 *
 * @param {string} code Código de autorización.
 * @param {string} state Token anti-falsificación.
 * @returns {Promise<IClaveUnicaTokenResponse>} Token de Clave Única.
 */
export const getToken = async (
  code: string,
  state: string
): Promise<IClaveUnicaTokenResponse> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_GCR_URL}/claveUnicaConexion/token?state=${state}&code=${code}`,
      null,
      {
        headers: {
          "x-api-key": `Basic ${getAuthToken()}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Método que inicia sesión en la aplicación.
 *
 * @param {string} token Token de Clave Única.
 * @returns {Promise<IClaveUnicaLoginResponse>} Datos de la sesión.
 */
export const login = async (
  token: string
): Promise<IClaveUnicaLoginResponse> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_GCR_URL}/auth/login`,
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": `Basic ${getAuthToken()}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Método que cierra sesión en la aplicación.
 * 
 * @returns {Promise<boolean>} Indica si la sesión fue cerrada correctamente.
 */
export const logout = async (): Promise<boolean> => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_CLAVE_UNICA_BASE_URL}/api/v1/accounts/app/logout?redirect=${process.env.REACT_APP_CLAVE_UNICA_LOGOUT_REDIRECT_URL}`
    );

    return response.status === 200;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
